<template>
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4011_4280)">
      <path
        d="M3.3335 18.1855V21.9355H7.0835L18.1435 10.8755L14.3935 7.12555L3.3335 18.1855ZM6.2535 19.9355H5.3335V19.0155L14.3935 9.95555L15.3135 10.8755L6.2535 19.9355ZM21.0435 6.56555L18.7035 4.22555C18.5035 4.02555 18.2535 3.93555 17.9935 3.93555C17.7335 3.93555 17.4835 4.03555 17.2935 4.22555L15.4635 6.05555L19.2135 9.80555L21.0435 7.97555C21.4335 7.58555 21.4335 6.95555 21.0435 6.56555Z"
        fill="#383838"
      />
    </g>
    <defs>
      <clipPath id="clip0_4011_4280">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0.333496 0.935547)"
        />
      </clipPath>
    </defs>
  </svg>
</template>
